import {Provider} from '@angular/core';

import {
  ListAgreementUseCaseProvider
} from '@features/agreement/presentation/providers/list-agreement/list-agreement.use-case.provider';

import {ListAgreementFacade} from '@features/agreement/presentation/facades/list-agreement/list-agreement.facade';

export const ListAgreementFacadeProvider: Provider[] = [
  ListAgreementUseCaseProvider,
  ListAgreementFacade
];
